/**
 * <Card> — nested surface wrapper for grouped content inside the work-surface.
 *
 * Props:
 *  - title       : header title (string)
 *  - description : optional sub-text under the title
 *  - actions     : right-aligned slot in the header (e.g. a Remove button)
 *  - children    : card body
 */
export default function Card({ title, description, actions, children, className }) {
  const cls = 'form-card' + (className ? ' ' + className : '')
  const showHeader = !!(title || actions || description)
  return (
    <section className={cls}>
      {showHeader && (
        <header className="form-card-header">
          <div className="form-card-header-text">
            {title && <h3 className="form-card-title">{title}</h3>}
            {description && <p className="form-card-desc">{description}</p>}
          </div>
          {actions && <div className="form-card-actions">{actions}</div>}
        </header>
      )}
      <div className="form-card-body">{children}</div>
    </section>
  )
}
